<template>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { computed, onMounted, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import routeName from '@/router/constant.js';
import { postVerifySubmitNotify } from '@/apis/eNotifyPromo';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    setup() {
        const store = useStore();
        const router = useRouter();

        const userId = computed(() => store.state.eNotify.user.id || '');
        onMounted(() => {
            if (!userId.value) {
                router.push({
                    name: routeName.ENOTIFY,
                });
            }
        });
        const users = reactive({
            id: userId.value,
            account: '',
            password: '',
            verifyCode: '',
            errors: {
                account: '',
                password: '',
                verifyCode: '',
            },
            reFresh: false,
        });

        const isLoading = ref(false);

        //    const { message } = textLength({
        // const validateAccount = (value) => {
        //        value,
        //        min: 8,
        //        fieldName: '帳號',
        //    });
        //    users.errors.account = message;
        // };
        // const validatePassword = (value) => {
        //    const { message } = textLength({
        //        value,
        //        min: 8,
        //        fieldName: '密碼',
        //    });
        //    users.errors.password = message;
        // };
        // const validateVerifyCode = (value) => {
        //    if (value === '') {
        //        users.errors.verifyCode = '請輸入驗證碼';
        //    } else if (!isPassVerified.value) {
        //        users.errors.verifyCode = '請輸入正確的驗證碼';
        //    }
        // };

        // 送出登入
        const login = () => {
            const data = {
                myId: '',
                password: '',
                verifyCode: '',
                callBackParam: '',
            };
            return postVerifySubmitNotify(data).then(res => {
                return true;
            }).catch(err => {
                if (err.data?.redirectUrl) {
                    return;
                }
                isLoading.value = false;
                openPopupCatchMessage(err);
                users.reFresh = true;
                users.account = '';
                users.password = '';
                users.verifyCode = '';
            });
        };

        // 登入過程
        // async () => {
        if (login()) {
            router.push({
                name: routeName.ENOTIFY_SELECT_EMAIL,
            });
        }
        // };

        return {
            ...toRefs(users),
            isLoading,
        };
    },
};
</script>
<style lang="scss" scoped>
</style>
